// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2Ihd_","label":"Category_label__2NPMK","content":"Category_content__3vXr3","header":"Category_header__SbwF3","location":"Category_location__bWg1M"};